/**
 * ThemeContext.js
 *
 * Copiado de hay-hotspot/assets/reactweb/src/context/ThemeContext.js (Fase 1.6) — 100%
 * genérico, sem mudanças.
 */
import React, { Component, createContext } from 'react';
import { PrimeReactProvider, PrimeReactContext, addLocale } from 'primereact/api';
import ptBr from 'primelocale/pt-BR.json';
import { UtilService } from 'hay-core-react';
addLocale('pt-BR', ptBr['pt-BR']);

export const ThemeContext = createContext(null);

const DEFAULT_TEMA = {
  scale: 14,
  ripple: true,
  inputStyle: 'outlined',
  darkMode: false,
  currentTheme: 'lara-light-indigo',
};

function loadTema() {
  const auth = UtilService.getLocalStorage('auth');
  return { ...DEFAULT_TEMA, ...(auth?.tema ?? {}) };
}

function saveTema(patch) {
  const auth = UtilService.getLocalStorage('auth') ?? {};
  UtilService.saveLocalStorage('auth', {
    ...auth,
    tema: { ...(auth.tema ?? {}), ...patch },
  });
}

// Aplica o tema salvo na montagem inicial trocando o <link id="theme-link">
class ThemeInitializer extends Component {
  componentDidMount() {
    const { changeTheme } = this.props.primeCtx;
    const { currentTheme } = this.props.themeCtx;
    if (currentTheme !== DEFAULT_TEMA.currentTheme) {
      changeTheme(DEFAULT_TEMA.currentTheme, currentTheme, 'theme-link', () => {});
    }
  }

  render() {
    return this.props.children;
  }
}

export class ThemeProvider extends Component {
  constructor(props) {
    super(props);
    const saved = loadTema();
    this.state = { ...saved };
    document.documentElement.style.fontSize = saved.scale + 'px';

    this.setScale = this.setScale.bind(this);
    this.setRipple = this.setRipple.bind(this);
    this.setInputStyle = this.setInputStyle.bind(this);
    this.setDarkMode = this.setDarkMode.bind(this);
    this.setCurrentTheme = this.setCurrentTheme.bind(this);
  }

  setScale(v) { this.setState({ scale: v }); saveTema({ scale: v }); document.documentElement.style.fontSize = v + 'px'; }
  setRipple(v) { this.setState({ ripple: v }); saveTema({ ripple: v }); }
  setInputStyle(v) { this.setState({ inputStyle: v }); saveTema({ inputStyle: v }); }
  setDarkMode(v) { this.setState({ darkMode: v }); saveTema({ darkMode: v }); }
  setCurrentTheme(v) { this.setState({ currentTheme: v }); saveTema({ currentTheme: v }); }

  render() {
    const { scale, ripple, inputStyle, darkMode, currentTheme } = this.state;
    const ctx = {
      scale, setScale: this.setScale,
      ripple, setRipple: this.setRipple,
      inputStyle, setInputStyle: this.setInputStyle,
      darkMode, setDarkMode: this.setDarkMode,
      currentTheme, setCurrentTheme: this.setCurrentTheme,
    };
    return (
      <ThemeContext.Provider value={ctx}>
        <PrimeReactProvider value={{ ripple, inputStyle, locale: 'pt-BR' }}>
          <PrimeReactContext.Consumer>
            {(primeCtx) => (
              <ThemeInitializer primeCtx={primeCtx} themeCtx={ctx}>
                {this.props.children}
              </ThemeInitializer>
            )}
          </PrimeReactContext.Consumer>
        </PrimeReactProvider>
      </ThemeContext.Provider>
    );
  }
}
